import { useTranslation } from 'react-i18next'

import {
  EMPTY_FUNCTION,
  FLOATING_ELEMENT_PLACEMENT,
} from '../../../../constants/common'
import { getQaSelector } from '../../../../utils/common'
import { stopPropagation } from '../../../../utils/events'
import Button, { BUTTON_HEIGHT_24 } from '../../../Button'
import { ICON_HEIGHT_16 } from '../../../Icon'
import { GretaAIChatMessageRole } from '../../GretaAIChat.constants'
import { GretaAIChatCopyButton } from '../GretaAIChatCopyButton'
import {
  QA_NAME_GRETA_AI_CHAT_MESSAGE_ACTIONS,
  QA_NAME_GRETA_AI_CHAT_MESSAGE_RETRY,
} from '../GretaAIChatMessageActions.constants'
import { GretaAIChatMessageTime } from '../GretaAIChatMessageTime'

import * as styles from './GretaAIChatUserActions.module.css'

import RefreshIcon from '../../../../icons/refresh.svg'

function GretaAIChatUserActions({
  canRetry = false,
  className = styles.actions,
  contentRef,
  createdAt,
  isLimitReached = false,
  now,
  text,
  onRetry = EMPTY_FUNCTION,
}) {
  const { t } = useTranslation()

  function handleRetry(event) {
    stopPropagation(event)
    onRetry()
  }

  const qaProps = getQaSelector({
    context: GretaAIChatMessageRole.User,
    value: QA_NAME_GRETA_AI_CHAT_MESSAGE_ACTIONS,
  })

  return (
    <div {...qaProps} className={className}>
      <GretaAIChatMessageTime createdAt={createdAt} now={now} />

      {canRetry ? (
        <Button.Icon
          isGrey
          Icon={RefreshIcon}
          beforeIconProps={{ height: ICON_HEIGHT_16 }}
          className={styles.actionButton}
          disabled={isLimitReached}
          height={BUTTON_HEIGHT_24}
          qaName={QA_NAME_GRETA_AI_CHAT_MESSAGE_RETRY}
          tooltip={t('Greta.RetryButtonKey')}
          tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
          onClick={handleRetry}
        />
      ) : null}

      <GretaAIChatCopyButton
        className={styles.actionButton}
        contentRef={contentRef}
        text={text}
      />
    </div>
  )
}

export default GretaAIChatUserActions
